$(document).ready(function () {
    $('.mediaSlider a').each(function () {
        $(this).attr("data-fancybox", "images");
        $(this).attr('href').indexOf('youtube') > 0 ? $('a', this).attr("data-type", "iframe") : $('a', this).attr("data-fancybox", "images");
    });

    $('[data-fancybox]').fancybox({
        iframe : {
            css : {
                width : '600px'
            }
        },
        hash: false,
        youtube: {
            autoplay: 1,
            autohide: 1,
            fs: 1,
            rel: 0,
            hd: 1,
            wmode: 'opaque',
            enablejsapi: 1
        },
        arrows: true
    });
});